import React, { useState, useEffect } from 'react';
import './LlibretsComponent.css';
import { Link } from 'react-router-dom';
import ImageWithLoader from '../ImageWithLoader';

export const Llibrets = (props) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 8;
  const totalPages = Math.ceil(props.Data.length / itemsPerPage);
  const [yearRanges, setYearRanges] = useState([]);

  useEffect(() => {
    updateYearRanges();
  }, [props.Data, page, totalPages]);

  const updateYearRanges = () => {
    const ranges = [];
    let startIndex = 0;
    let endIndex = 0;

    for (let i = 1; i <= totalPages; i++) {
      startIndex = (i - 1) * itemsPerPage;
      endIndex = Math.min(startIndex + itemsPerPage, props.Data.length);
      const startYear = props.Data[startIndex]?.year;
      const endYear = props.Data[endIndex - 1]?.year;
      ranges.push(`${startYear} - ${endYear}`);
    }

    setYearRanges(ranges);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className='LlibretsComponent'>
      <h1 className='titulo-page'>{props.I18n.OurLlibrets}</h1>

      <div className='paginado'>
        {pageNumbers.map((pageNumber, index) => (
          <button
            key={pageNumber}
            onClick={() => handlePageChange(pageNumber)}
            className={pageNumber === page ? "selected" : ""}
          >
            ({yearRanges[index] || ''})
          </button>
        ))}
      </div>

      <div className='all-Llibret'>
        {props.Data
          .slice((page - 1) * itemsPerPage, page * itemsPerPage)
          .map((llibret) => (
            <div className='Llibret-content' key={llibret.year}>
              <h2>{llibret.year}</h2>
              <hr />
              <div className={`Llibret-images ${llibret.llibrets?.imagesMin?.length > 1 ? 'llibret-image-two' : ''}`}>
                {llibret.llibrets?.imagesMin?.map((imageMin, index) => (
                  <Link
                    to={llibret.llibrets.url}
                    target='_blank'
                    rel="noopener noreferrer"
                    key={index}
                  >
                    <ImageWithLoader
                      src={imageMin}  
                      alt="Llibret"
                      className='Llibret-image'
                    />
                  </Link>
                ))}
              </div>
              <hr />
            </div>
          ))}
      </div>
    </div>
  );
};
